import * as _4 from 'lodash4';
import { APPlannedCourse } from '../../global/builders/ap_planned_course_builder';
import { APProgramSlot } from '../builders/ap_program_slot_builder';

export class APMinGradeServant {
  static isMinGradeMet(programSlot: APProgramSlot, plannedCourse: APPlannedCourse, minGradeFeature: boolean) {
    const actualGrade = _4.get(plannedCourse, 'actual_grade_point', -1);
    const minGrade = _4.get(programSlot, 'min_grade_point', 0);
    if (!minGradeFeature) {
      return true;
    }
    if (_4.isNil(minGrade) || _4.isNil(actualGrade)) {
      return true;
    }
    if (actualGrade >= minGrade) {
      return true;
    }
    return false;
  }

  static progSlotEmptyPlannedCourseCompleted(programSlot: APProgramSlot, plannedCourse: APPlannedCourse) {
    return _4.isEmpty(programSlot.status) && _4.includes(['COMPLETED'], _4.get(plannedCourse, 'status', ''));
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/servants/ap_min_grade_servant.ts